import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FooterHeightService {
  private footerHeightSource = new BehaviorSubject<number>(0);
  footerHeight$ = this.footerHeightSource.asObservable();

  public setFooterHeight(height: number) {
    this.footerHeightSource.next(height);
  }
}
